const constructionTypes = [
  'Terrasse',
  'Anneks',
  'Carport',
  'Drivhus',
  'Skur',
  'Modulbyggeri',
  'Andet'
];

const fundamentsPlanApprovalOptions = [
  'Godkendt',
  'Ikke godkendt'
];

const directionOptions = [
  'Nord',
  'Syd',
  'Øst',
  'Vest'
];

const measurementApprovalOptions = [
  'Ikke godkendt - der fremsendes ny tegning',
  'Godkendt'
];

const lastNedfoeringsplan = [
  'Godkendt',
  'Ikke godkendt - der fremsendes ny plan',
  'Vi ønsker at gøre brug af en estimeret vægtberegning af bygningen, udført af Normann Olsen Skruefundament uden ansvarstagen for korrektheden',
];

const koteplan = [
  'Godkendt',
  'Ikke godkendt - der fremsendes ny plan',
  'Ved ikke - vi ønsker at gøre brug af anbefalingen fra Normann Olsen Skruefundament, hvilket betyder at skruens top, placeres 20cm over højeste punkt indenfor afsatte byggefelte',
];

const jordforhold = [
  'Der haves ikke kendskab til el, vand, kloak eller dræn i jorden konflikter med byggeriet – Jeg giver hermed tilladelse til, at Normann Olsen Skruefundament kan montere uden ansvar for ovenstående.',
  'Forhold ønskes undersøgt nærmere – kunden undersøger selv forholdene og fremsender særskilt information til NOMS inden udførsel',
  'Forhold ønskes undersøgt nærmere – og jeg ønsker NOMS assistance med: (se tilkøb)',
];



export default function ProjectInfoSection({ values, onChange, errors }) {
  return (
    <section>
      <h2 className="text-xl font-bold text-primary mb-4">Projektinformationer</h2>
      <div className="space-y-4">

        {/* Building Information Section */}
        <div className="mt-6 pt-4 border-t border-gray-200">

          {/* Construction Type */}
          <div className="mb-4">
            <label className="block font-bold text-primary mb-1" htmlFor="constructionType">Type af konstruktion</label>
            <select
              id="constructionType"
              name="constructionType"
              className="w-full rounded-form border border-gray-300 px-4 py-3 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium"
              value={values.constructionType || ''}
              onChange={e => onChange('constructionType', e.target.value)}
            >
              <option value="">Vælg konstruktionstype</option>
              {constructionTypes.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
            {errors.constructionType && (
              <p className="text-red-600 text-sm mt-1">{errors.constructionType}</p>
            )}
          </div>

          {/* Fundament Plan */}
          <div className="mb-4">
            <label className="block font-bold text-primary mb-1">
              Fundamentsplan
              {values.link_fundamentsplan && (
                <span className="ml-2">
                  <a
                    href={values.link_fundamentsplan}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-brand-orange underline hover:text-orange-600"
                  >
                    (Se plan)
                  </a>
                </span>
              )}
            </label>
            <div className="flex gap-4">
              {fundamentsPlanApprovalOptions.map(option => (
                <label key={option} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="fundaments_plan_approval"
                    value={option}
                    checked={values.fundaments_plan_approval === option}
                    onChange={() => onChange('fundaments_plan_approval', option)}
                    className="accent-accent"
                    required
                  />
                  <span className="text-primary">{option}</span>
                </label>
              ))}
            </div>
            {errors.fundaments_plan_approval && (
              <p className="text-red-600 text-sm mt-1">{errors.fundaments_plan_approval}</p>
            )}
          </div>

          {/* Opmåling og afsætnings plan */}
          <div className="mb-4">
            <label className="block font-bold text-primary mb-1">
              Opmåling
              {values.link_measurement_method_plan && (
                <span className="ml-2">
                  <a
                    href={values.link_measurement_method_plan}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-brand-orange underline hover:text-orange-600"
                  >
                    (Se plan)
                  </a>
                </span>
              )}
            </label>
            {/* Option 1: Jeg sætter selv punkter */}
            <div className="mb-3">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  name="ext_measurement_method_customer"
                  checked={values.ext_measurement_method === 'kunden'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      onChange('ext_measurement_method', 'kunden');
                      // Clear other sub-options when switching
                      onChange('ext_measurement_method_link_approved', '');
                    } else {
                      onChange('ext_measurement_method', '');
                      onChange('ext_measurement_method_fixed', '');
                    }
                  }}
                  className="accent-accent"
                />
                <span className="text-primary">Jeg sætter selv punkter</span>
              </label>

              {/* Option 1.1: Direction dropdown */}
              {values.ext_measurement_method === 'kunden' && (
                <div className="ml-6 mt-2">
                  <label className="block font-bold text-primary mb-1" htmlFor="ext_measurement_method_fixed">Retning</label>
                  <select
                    id="ext_measurement_method_fixed"
                    name="ext_measurement_method_fixed"
                    className="w-full rounded-form border border-gray-300 px-4 py-3 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium"
                    value={values.ext_measurement_method_fixed || ''}
                    onChange={e => onChange('ext_measurement_method_fixed', e.target.value)}
                  >
                    <option value="">Vælg retning</option>
                    {directionOptions.map(direction => (
                      <option key={direction} value={direction}>{direction}</option>
                    ))}
                  </select>
                </div>
              )}
            </div>

            {/* Option 2: Landmåler har sat ude, NO sætter inde */}
            <div className="mb-3">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  name="ext_measurement_method_landmaaler_no"
                  checked={values.ext_measurement_method === 'landmåler og NO'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      onChange('ext_measurement_method', 'landmåler og NO');
                      // Clear other sub-options when switching
                      onChange('ext_measurement_method_fixed', '');
                    } else {
                      onChange('ext_measurement_method', '');
                      onChange('ext_measurement_method_link_approved', '');
                    }
                  }}
                  className="accent-accent"
                />
                <span className="text-primary">Landmåler har sat ude, NO sætter inde</span>
              </label>

              {/* Option 2.1: Approval radio with link */}
              {values.ext_measurement_method === 'landmåler og NO' && (
                <div className="ml-6 mt-2">
                  <label className="block font-bold text-primary mb-1">
                    Status                 </label>
                  <div className="flex flex-col gap-2">
                    {measurementApprovalOptions.map(option => (
                      <label key={option} className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="radio"
                          name="ext_measurement_method_link_approved"
                          value={option === 'Godkendt' ? 'true' : 'false'}
                          checked={values.ext_measurement_method_link_approved === (option === 'Godkendt' ? 'true' : 'false')}
                          onChange={() => onChange('ext_measurement_method_link_approved', option === 'Godkendt' ? 'true' : 'false')}
                          className="accent-accent"
                        />
                        <span className="text-primary">{option}</span>
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Option 3: Landmåler har sat alle punkter */}
            <div className="mb-3">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  name="ext_measurement_method_landmaaler"
                  checked={values.ext_measurement_method === 'landmåler'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      onChange('ext_measurement_method', 'landmåler');
                      // Clear other sub-options when switching
                      onChange('ext_measurement_method_fixed', '');
                    } else {
                      onChange('ext_measurement_method', '');
                      onChange('ext_measurement_method_link_approved', '');
                    }
                  }}
                  className="accent-accent"
                />
                <span className="text-primary">Landmåler har sat alle punkter</span>
              </label>

              {/* Option 3.1: Approval radio with link */}
              {values.ext_measurement_method === 'landmåler' && (
                <div className="ml-6 mt-2">
                  <label className="block font-bold text-primary mb-1">
                    Status
                  </label>
                  <div className="flex flex-col gap-2">
                    {measurementApprovalOptions.map(option => (
                      <label key={option} className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="radio"
                          name="ext_measurement_method_link_approved"
                          value={option === 'Godkendt' ? 'true' : 'false'}
                          checked={values.ext_measurement_method_link_approved === (option === 'Godkendt' ? 'true' : 'false')}
                          onChange={() => onChange('ext_measurement_method_link_approved', option === 'Godkendt' ? 'true' : 'false')}
                          className="accent-accent"
                        />
                        <span className="text-primary">{option}</span>
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {errors.ext_measurement_method && (
              <p className="text-red-600 text-sm mt-1">{errors.ext_measurement_method}</p>
            )}
          </div>

          {/* Skrueplacering ift. byggefacade */}
          <div className="mb-4">
            <label className="block font-bold text-primary mb-1">Skrueplacering ift. byggefacade</label>
            <div className="space-y-3">
              <div className="flex items-center gap-2">

                <input
                  type="number"
                  name="distance_build_to_center"
                  className="w-20 rounded-form border border-gray-300 px-3 py-2 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium text-center"
                  value={values.distance_build_to_center || 15}
                  onChange={e => onChange('distance_build_to_center', parseInt(e.target.value) || 15)}
                  min="1"
                  required
                />
                <span className="text-primary"><b>cm</b> fra bygnings facade til skruens center</span>
              </div>
            </div>
            {errors.distance_build_to_center && (
              <p className="text-red-600 text-sm mt-1">{errors.distance_build_to_center}</p>
            )}
          </div>
        </div>

        {/* Vægt og Belastning Section */}
        <div className="mt-6 pt-4 border-t border-gray-200">
          <h3 className="text-lg font-bold text-primary mb-3">Vægt og Belastning</h3>

          {/* Total Weight */}
          <div className="mb-4">
            <label className="block font-bold text-primary mb-1">Bygningens totalvægt</label>
            <div className="flex items-center gap-2">
              <input
                type="number"
                name="total_weight_kg"
                className="w-24 rounded-form border border-gray-300 px-3 py-2 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium text-center"
                value={values.total_weight_kg || ''}
                onChange={e => onChange('total_weight_kg', parseInt(e.target.value) || 0)}
                min="1"
                required
              />
              <span className="text-primary"><b>kg</b></span>
            </div>
            {errors.total_weight_kg && (
              <p className="text-red-600 text-sm mt-1">{errors.total_weight_kg}</p>
            )}
          </div>

          {/* Lastneføringsplan */}
          <div className="mb-4">
            <label className="block font-bold text-primary mb-1">
              Lastnedføringsplan
              {values.link_lastnedfoeringsplan && (
                <span className="ml-2">
                  <a
                    href={values.link_lastnedfoeringsplan}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-brand-orange underline hover:text-orange-600"
                  >
                    (Se plan)
                  </a>
                </span>
              )}
            </label>
            <div className="flex flex-col gap-2">
              {lastNedfoeringsplan.map(option => (
                <label key={option} className="flex items-start gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="lastNedfoeringsplan_approval"
                    value={option}
                    checked={values.lastNedfoeringsplan_approval === option}
                    onChange={() => onChange('lastNedfoeringsplan_approval', option)}
                    className="accent-accent mt-1"
                    required
                  />
                  <span className="text-primary">{option}</span>
                </label>
              ))}
            </div>
            {errors.lastNedfoeringsplan_approval && (
              <p className="text-red-600 text-sm mt-1">{errors.lastNedfoeringsplan_approval}</p>
            )}
          </div>
        </div>
        {/* Kotehøjde section */}
        <div className="mt-6 pt-4 border-t border-gray-200">
          <h3 className="text-lg font-bold text-primary mb-3">Kotehøjde</h3>
          <div className="mb-4">
            <label className="block font-bold text-primary mb-1">Skruens top, ønskede højde</label>
            <div className="flex items-center gap-2">
              <input
                type="number"
                name="screw_height_from_ground"
                className="w-24 rounded-form border border-gray-300 px-3 py-2 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium text-center"
                value={values.screw_height_from_ground || ''}
                onChange={e => onChange('screw_height_from_ground', parseInt(e.target.value) || 0)}
                min="1"
                required
              />
              <span className="text-primary"><b>cm </b>fra jordens top</span>
            </div>
            {errors.screw_height_from_ground && (
              <p className="text-red-600 text-sm mt-1">{errors.screw_height_from_ground}</p>
            )}
          </div>
          <div className="mb-4">
            <label className="block font-bold text-primary mb-1">Byggefeltets skråninger </label>
            <div className="flex items-center gap-2">
              <input
                type="number"
                name="skraaninger"
                className="w-24 rounded-form border border-gray-300 px-3 py-2 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium text-center"
                value={values.skraaninger || ''}
                onChange={e => onChange('skraaninger', parseInt(e.target.value) || 0)}
                min="1"
                required
              />
              <span className="text-primary"><b>cm </b></span>
            </div>
            {errors.skraaninger && (
              <p className="text-red-600 text-sm mt-1">{errors.skraaninger}</p>
            )}
          </div>

          {/* Koteplan */}
          <div className="mb-4">
            <label className="block font-bold text-primary mb-1">
              Koteplan
              {values.link_koteplan && (
                <span className="ml-2">
                  <a
                    href={values.link_koteplan}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-brand-orange underline hover:text-orange-600"
                  >
                    (Se plan)
                  </a>
                </span>
              )}
            </label>
            <div className="flex flex-col gap-2">
              {koteplan.map(option => (
                <label key={option} className="flex items-start gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="koteplan_approval"
                    value={option}
                    checked={values.koteplan_approval === option}
                    onChange={() => onChange('koteplan_approval', option)}
                    className="accent-accent mt-1"
                    required
                  />
                  <span className="text-primary">{option}</span>
                </label>
              ))}
            </div>
            {errors.koteplan_approval && (
              <p className="text-red-600 text-sm mt-1">{errors.koteplan_approval}</p>
            )}
          </div>

          {/* Jordbundsforhold */}
          <div className="mt-6 pt-4 border-t border-gray-200">
            <h3 className="text-lg font-bold text-primary mb-3">Jordbundsforhold </h3>
            <div className="mb-4">
              <label className="block font-bold text-primary mb-1">
                Jordbundsanalyse
                {values.link_jordbundsanalyse && (
                  <span className="ml-2">
                    <a
                      href={values.link_jordbundsanalyse}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-brand-orange underline hover:text-orange-600"
                    >
                      (Se plan)
                    </a>
                  </span>
                )}
              </label>

              <div className="mb-3">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    name="jordbundsanalyse_done"
                    value={values.jordbundsanalyse_done || ''}
                    checked={values.jordbundsanalyse_done === 'true'}
                    onChange={e => onChange('jordbundsanalyse_done', e.target.checked ? 'true' : 'false')}
                    className="accent-accent"
                  />
                  <span className="text-primary">Geoteknisk undersøgelse er udført og kopi er er fremsendt til Normann Olsen Skruefundament</span>
                </label>
              </div>

              <div className="mb-3">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    name="jordbundsanalyse_none"
                    value={values.jordbundsanalyse_none || ''}
                    checked={values.jordbundsanalyse_none === 'true'}
                    onChange={e => onChange('jordbundsanalyse_none', e.target.checked ? 'true' : 'false')}
                    className="accent-accent"
                  />
                  <span className="text-primary">Ingen geoteknisk undersøgelse</span>
                </label>
                {values.jordbundsanalyse_none === 'true' && (
                  <div className="ml-6 mt-2">
                    <label className="block font-bold text-primary mb-1">OSBL</label>
                    <div className="flex items-center gap-2">
                      <input
                        type="number"
                        name="jordbundsanalyse_osbl"
                        className="w-24 rounded-form border border-gray-300 px-3 py-2 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium text-center"
                        value={values.jordbundsanalyse_osbl || ''}
                        onChange={e => onChange('jordbundsanalyse_osbl', parseInt(e.target.value) || 0)}
                        min="1"
                        placeholder="Indtast værdi"
                      />
                      <span className="text-primary"><b>cm</b> bla bla bla</span>
                    </div>
                    {errors.jordbundsanalyse_osbl && (
                      <p className="text-red-600 text-sm mt-1">{errors.jordbundsanalyse_osbl}</p>
                    )}
                  </div>
                )}
              </div>

            </div>

            {/* Kendskab til underjordiske forhold */}
            <div className="mb-4">
              <label className="block font-bold text-primary mb-1">
                Kendskab til el, vand, kloak eller dræn i jorden
              </label>
              <div className="flex flex-col gap-2">
                {jordforhold.map(option => (
                  <label key={option} className="flex items-start gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="jordforhold_kendskab"
                      value={option}
                      checked={values.jordforhold_kendskab === option}
                      onChange={() => onChange('jordforhold_kendskab', option)}
                      className="accent-accent mt-1"
                      required
                    />
                    <span className="text-primary">{option}</span>
                  </label>
                ))}
              </div>
              {errors.jordforhold_kendskab && (
                <p className="text-red-600 text-sm mt-1">{errors.jordforhold_kendskab}</p>
              )}
            </div>

            {/* Jordforhold Comment */}
            <div className="mb-4">
              <label className="block font-bold text-primary mb-1" htmlFor="jordforhold_comment">
                Kendskab til underjordiske forhold
              </label>
              <textarea
                id="jordforhold_comment"
                name="jordforhold_comment"
                className="w-full rounded-form border border-gray-300 px-4 py-3 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium"
                value={values.jordforhold_comment || ''}
                onChange={e => onChange('jordforhold_comment', e.target.value)}
                rows="4"
                placeholder="Indtast kommentarer med relevans for jorbundsforhold. Eksemeplvis jordvarme, kabler eller anden nedgravet teknik. Evt. udlægning af opfuld eller lignende på grunden kommentarer"
              />
              {errors.jordforhold_comment && (
                <p className="text-red-600 text-sm mt-1">{errors.jordforhold_comment}</p>
              )}
            </div>
            <div className="mt-6 pt-4 border-t border-gray-200">
              <h3 className="text-lg font-bold text-primary mb-3">Tilkøb </h3>

              {/* Gravedag / terræn nivellering */}
              <div className="mb-4">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    name="tilkoeb_gravedag"
                    checked={values.tilkoeb_gravedag === 'true'}
                    onChange={e => onChange('tilkoeb_gravedag', e.target.checked ? 'true' : 'false')}
                    className="accent-accent mt-1"
                  />
                  <span className="text-primary">Gravedag / terræn nivellering (7.000 kr = 1 dags gravearbejde inklusiv mand, maskine og brændstof)</span>
                </label>
              </div>

              {/* Prøvegravning */}
              <div className="mb-4">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    name="tilkoeb_proevegravning"
                    checked={values.tilkoeb_proevegravning === 'true'}
                    onChange={e => onChange('tilkoeb_proevegravning', e.target.checked ? 'true' : 'false')}
                    className="accent-accent mt-1"
                  />
                  <span className="text-primary">Prøvegravning (7.000 kr gravning for 2-3 steder)</span>
                </label>
                {values.tilkoeb_proevegravning === 'true' && (
                  <div className="ml-6 mt-2">
                    <label className="block text-primary mb-1">Hvad skal der søges efter:</label>
                    <input
                      type="text"
                      name="tilkoeb_proevegravning_details"
                      className="w-full rounded-form border border-gray-300 px-4 py-3 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium"
                      value={values.tilkoeb_proevegravning_details || ''}
                      onChange={e => onChange('tilkoeb_proevegravning_details', e.target.value)}
                      placeholder="Hvad skal der søges efter"
                    />
                  </div>
                )}
              </div>

              {/* LER-søgning */}
              <div className="mb-4">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    name="tilkoeb_ler_soegning"
                    checked={values.tilkoeb_ler_soegning === 'true'}
                    onChange={e => onChange('tilkoeb_ler_soegning', e.target.checked ? 'true' : 'false')}
                    className="accent-accent mt-1"
                  />
                  <span className="text-primary">LER-søgning, indhentning af offentligt tilgængelige ledningsinformationer på en martrikel (1.250 kr inkl. moms)</span>
                </label>
              </div>

              {/* Find ledning / kabel */}
              <div className="mb-4">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    name="tilkoeb_find_ledning"
                    checked={values.tilkoeb_find_ledning === 'true'}
                    onChange={e => onChange('tilkoeb_find_ledning', e.target.checked ? 'true' : 'false')}
                    className="accent-accent mt-1"
                  />
                  <span className="text-primary">Find 1 stk ledning / kabel med +230v med kabelsøger (3.000 kr inkl. moms)</span>
                </label>
              </div>

              {/* Ingeniør beregninger */}
              <div className="mb-4">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    name="tilkoeb_ingenioer_beregninger"
                    checked={values.tilkoeb_ingenioer_beregninger === 'true'}
                    onChange={e => onChange('tilkoeb_ingenioer_beregninger', e.target.checked ? 'true' : 'false')}
                    className="accent-accent mt-1"
                  />
                  <span className="text-primary">Ingeniør beregninger (estimat 12.000 kr for beregning af lastningføring til skruer)</span>
                </label>
              </div>

              {/* Jordbundsanalyse */}
              <div className="mb-4">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    name="tilkoeb_jordbundsanalyse"
                    checked={values.tilkoeb_jordbundsanalyse === 'true'}
                    onChange={e => onChange('tilkoeb_jordbundsanalyse', e.target.checked ? 'true' : 'false')}
                    className="accent-accent mt-1"
                  />
                  <span className="text-primary">Jordbundsanalyse (10.000kr for 2 stk boringer udført at geo tekniks firma)</span>
                </label>
              </div>

              {/* Landmåler afsætning */}
              <div className="mb-4">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    name="tilkoeb_landmaaler_afsaetning"
                    checked={values.tilkoeb_landmaaler_afsaetning === 'true'}
                    onChange={e => onChange('tilkoeb_landmaaler_afsaetning', e.target.checked ? 'true' : 'false')}
                    className="accent-accent mt-1"
                  />
                  <span className="text-primary">Landmåler afsætning (10.000kr for 4 stk afsætnigspinde) (lokalisering af skel og afsætning af galger koster ekstra)</span>
                </label>
              </div>

              {/* Punkt afsætning */}
              <div className="mb-4">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    name="tilkoeb_punkt_afsaetning"
                    checked={values.tilkoeb_punkt_afsaetning === 'true'}
                    onChange={e => onChange('tilkoeb_punkt_afsaetning', e.target.checked ? 'true' : 'false')}
                    className="accent-accent mt-1"
                  />
                  <span className="text-primary">Punkt afsætning af Normann Olsen Skruefundament (3.000kr for alle punkter indenfor byggefelt afsat af landmåler)</span>
                </label>
              </div>

              {/* Byggetilladelse */}
              <div className="mb-4">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    name="tilkoeb_byggetilladelse"
                    checked={values.tilkoeb_byggetilladelse === 'true'}
                    onChange={e => onChange('tilkoeb_byggetilladelse', e.target.checked ? 'true' : 'false')}
                    className="accent-accent mt-1"
                  />
                  <span className="text-primary">Byggetilladelse (20.000kr, indhentning af byggetilladelse og rentegning af skitser - udført af arkitekt)</span>
                </label>
              </div>

            </div>
          </div>
        </div>
      </div>

    </section>
  );
}
